import { func, string } from 'prop-types'
import './index.scss'
const Error = ({ errorMessage, handleError, buttonText, className }) => {
  return (
    <div className={`Error-handler ${className || ''}`}>
      <p>{errorMessage}</p>
      {handleError && (
        <button
          className="Error-handler-button"
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()

            handleError()
          }}
        >
          {buttonText}
        </button>
      )}
    </div>
  )
}

Error.propTypes = {
  errorMessage: string.isRequired,
  buttonText: string,
  handleError: func,
  className: string,
}

export default Error
